import { render, staticRenderFns } from "./View_Leaderboard.vue?vue&type=template&id=781671c0&scoped=true&"
import script from "./View_Leaderboard.vue?vue&type=script&lang=js&"
export * from "./View_Leaderboard.vue?vue&type=script&lang=js&"
import style0 from "./View_Leaderboard.vue?vue&type=style&index=0&id=781671c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781671c0",
  null
  
)

export default component.exports